import { NumberFormatter, Progress, Text } from '@mantine/core'
import classes from './KpiSummary.module.css'
import { IconStarFilled } from '@tabler/icons-react'

export default function KpiSummary({
  title,
  home_team_percentage,
  home_team_score,
  away_team_percentage,
  away_team_score,
}: {
  title: string
  home_team_percentage: number
  home_team_score: number
  away_team_percentage: number
  away_team_score: number
}) {
  // TODO fixed percentage thresholds
  const homeColor = home_team_percentage < 80 ? 'red.9' : 'green.9'
  const awayColor = away_team_percentage < 80 ? 'red.9' : 'green.9'

  return (
    <div className={classes.container}>
      <div className={classes.percentage_container}>
        <NumberFormatter
          className={classes.score}
          color={homeColor}
          decimalScale={1}
          fixedDecimalScale
          suffix="%"
          value={home_team_percentage}
        />
        <Text component="h6" className={classes.title}>
          {title}
        </Text>
        <NumberFormatter
          className={classes.score}
          color={awayColor}
          decimalScale={1}
          fixedDecimalScale
          suffix="%"
          value={away_team_percentage}
        />
      </div>
      <div className={classes.progress_container}>
        <div className={classes.home_team_progress_container}>
          <Progress.Root
            classNames={{ root: classes.home_team_root, label: classes.label }}
          >
            <Progress.Section value={home_team_percentage} color={homeColor} />
          </Progress.Root>
          <div className={classes.icons_container}>
            {Array.from({ length: home_team_score }).map((_, index) => (
              <IconStarFilled key={index} className={classes.icon} />
            ))}
          </div>
        </div>
        <Text component="p" className={classes.score}>
          {home_team_score}:{away_team_score}
        </Text>
        <div className={classes.away_team_progress_container}>
          <Progress.Root
            classNames={{ root: classes.root, label: classes.label }}
          >
            <Progress.Section value={away_team_percentage} color={awayColor} />
          </Progress.Root>
          <div className={classes.icons_container}>
            {Array.from({ length: away_team_score }).map((_, index) => (
              <IconStarFilled key={index} className={classes.icon} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
